import React from 'react';
import { ITag, Label, TagPicker } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { AvailableMedicalService } from '../../../../models/Entities/MedicalServices/AvailableMedicalService';

// own functions
import * as ownFunctions from './PractitionerMedicalServiceSelectorFunctions';
import { connect } from 'react-redux';

const PractitionerMedicalServiceSelectorComponent = (
  props: ownFunctions.Props
) => {

  useEffect(() => {
    // Misma página que el resto de las pantallas: el catálogo sirve de respaldo para resolver nombres.
    props.GetAllMedicalServices(1, 1000, false);
    props.GetMedicalServiceByPractitionerId(props.PractitionerId);
  }, []);

  const onChangeIdTextFieldValue = (items?: ITag[] | undefined) => {
    let MedicalServicesComboSelected: AvailableMedicalService[] = [];
    if (items && items.length > 0) {
      items.forEach((item: ITag) => {
        const MedicalServiceId = Number(item.key);
        const association = props.PractitionerMedicalServices?.find((assoc) => assoc.medicalService?.id === MedicalServiceId);
        const medicalservice =
          ownFunctions.ResolveAssociatedMedicalService(association, props.MedicalServices) ??
          props.MedicalServices?.find((service: AvailableMedicalService) => service.id === MedicalServiceId);
        if (medicalservice) {
          MedicalServicesComboSelected = [...MedicalServicesComboSelected, medicalservice];
        }
      });
      setInternalMedicalServicesSelected(MedicalServicesComboSelected);
      setMedicalServicesOptionsSelected(items);
    } else {
      setInternalMedicalServicesSelected([]);
      setMedicalServicesOptionsSelected([]);
    }
  };

  const [MedicalServiceOptions, setMedicalServiceOptions] = useState<ITag[]>();
  const [MedicalServicesOptionsSelected, setMedicalServicesOptionsSelected] =
    useState<ITag[]>();

  const [InternalMedicalServicesSelected, setInternalMedicalServicesSelected] =
    useState<AvailableMedicalService[]>([]);

  useEffect(() => {
    setMedicalServiceOptions(ownFunctions.GetMedicalServicesOptions(props.PractitionerMedicalServices, props.MedicalServices));
  }, []);

  useEffect(() => {
    props.onSelectedServices(InternalMedicalServicesSelected);
  }, [InternalMedicalServicesSelected]);

  useEffect(() => {
    if (MedicalServiceOptions) {
      const auxMedicalServicesSelected = MedicalServiceOptions.filter(
        (option: ITag) =>
          option.key === props.MedicalServicesSelected?.find((id: number) => id === option.key)
      );
      setMedicalServicesOptionsSelected(auxMedicalServicesSelected);
    }
  }, [MedicalServiceOptions]);

  useEffect(() => {
    if (props.MedicalServicesSelected) {
      const auxMedicalServicesSelected = props.MedicalServicesSelected.map((id: number) => {
        const association = props.PractitionerMedicalServices?.find((assoc) => assoc.medicalService?.id === id);
        const medicalService = ownFunctions.ResolveAssociatedMedicalService(association, props.MedicalServices);
        return { key: id, name: medicalService?.serviceNameReference || `#${id}` } as ITag;
      });
      setMedicalServicesOptionsSelected(auxMedicalServicesSelected);
    }
  }, []);

  const filterSuggestedMedicalServices = (filterText: string, tagList: ITag[] | undefined): ITag[] =>
    ownFunctions.FilterSuggestedMedicalServices(filterText, props.MedicalServicesOptions, tagList);

  return (
    <>
      <Label htmlFor="SnomedOption">Seleccione una práctica médica</Label>
      <TagPicker
        removeButtonAriaLabel="Eliminar"
        selectionAriaLabel="Seleccione un servicio"
        onResolveSuggestions={filterSuggestedMedicalServices}
        onEmptyResolveSuggestions={(selectedItems?: ITag[] | undefined) => props.MedicalServicesOptions || []}
        getTextFromItem={ownFunctions.getTextFromItem}
        pickerSuggestionsProps={ownFunctions.pickerSuggestionsProps}
        itemLimit={undefined}
        onChange={onChangeIdTextFieldValue}
        pickerCalloutProps={{ doNotLayer: false }}
        inputProps={{
          id: 'ServicesOption'
        }}
        selectedItems={MedicalServicesOptionsSelected}
      />
      {props.noteText && <small>{props.noteText}</small>}
    </>
  );
};

export default connect(
  ownFunctions.mapStateToProps,
  ownFunctions.mapDispatchToProps
)(PractitionerMedicalServiceSelectorComponent as any);

